import { render } from "./Bracket.vue?vue&type=template&id=23a3a63f"
import script from "./Bracket.vue?vue&type=script&lang=js"
export * from "./Bracket.vue?vue&type=script&lang=js"

import "./Bracket.vue?vue&type=style&index=0&id=23a3a63f&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__